import type { SVGProps } from "react";
export function UndoIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      data-slot="icon"
      fill="none"
      height={16}
      viewBox="0 0 16 16"
      width={16}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="m5.9354 1.11305c.20715-.172451.51485-.14447.6875.0625.17245.20719.14459.51489-.0625.6875l-2.08984 1.74122h3.34082c3.14632.00036 5.69702 2.55096 5.69722 5.69726 0 3.14647-2.5508 5.69787-5.69722 5.69827h-4.16797c-.26962 0-.48811-.2187-.48828-.4883 0-.2697.21856-.4883.48828-.4883h4.16797c2.60702-.0004 4.72072-2.1146 4.72072-4.72167-.0002-2.60687-2.1138-4.72034-4.72072-4.7207h-3.34082l2.08984 1.74121c.20716.17268.23516.48129.0625.68848-.17268.2068-.48042.23392-.6875.06152l-2.52539-2.10352c-.54668-.45557-.54668-1.29637 0-1.75195z"
        fill="currentColor"
      />
    </svg>
  );
}
